import { ContainerModule, interfaces } from "inversify";
import { cleanupRateLimiters } from "~/modules/ratelimiter/cleanupRateLimiters/cleanupRateLimiters";
import { createRateLimiter } from "~/modules/ratelimiter/RateLimiterFactory/createRateLimiter/createRateLimiter";
import { RateLimiter } from "~/modules/ratelimiter/RateLimiter/RateLimiter";
import { RateLimiterFactory } from "~/modules/ratelimiter/RateLimiterFactory/RateLimiterFactory";
import { RateLimiterImpl } from "~/modules/ratelimiter/RateLimiter/RateLimiterImpl/RateLimiterImpl";
import { RateLimiterOptions } from "~/modules/ratelimiter/RateLimiter/RateLimiterOptions";
import {
    cleanupRateLimitersRTTI,
    rateLimiterFactoryRTTI,
    rateLimiterMapRTTI,
    rateLimiterRTTI
} from "~/modules/ratelimiter/ratelimiter.rtti";

export const rateLimiterModuleContainer = new ContainerModule((bind: interfaces.Bind) => {
    bind<RateLimiter>(rateLimiterRTTI).to(RateLimiterImpl);
    bind<Map<string, RateLimiter>>(rateLimiterMapRTTI).toConstantValue(new Map());
    bind<RateLimiterFactory>(rateLimiterFactoryRTTI).toFactory((context: interfaces.Context): RateLimiterFactory => {
        return (options: RateLimiterOptions) => {
            return createRateLimiter(context.container, options);
        };
    });
    bind<Function>(cleanupRateLimitersRTTI).toDynamicValue((context: interfaces.Context) => {
        return () => cleanupRateLimiters(context.container);
    });
});
